'use client';

import dynamic from 'next/dynamic';

import { StrapiStop } from '@/apis/strapi';
import { useEffect, useState } from 'react';

const TrailwaysGoogleStopsMap = dynamic(() => import('@/components/global/maps/trailwaysGoogleStopsMap'), {
  ssr: false
});

interface Props {
  details: boolean | false;
  markerIndex: number | null;
  stops: StrapiStop[];
}

const DelayedTrailwaysGoogleStopsMap = (props: Props) => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasScrolled && window.scrollY > 0) {
        setHasScrolled(true);
        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    hasScrolled && (
      <TrailwaysGoogleStopsMap details={props.details} markerIndex={props.markerIndex} stops={props.stops} />
    )
  );
};
export default DelayedTrailwaysGoogleStopsMap;
